import api from '../api';

class DataServiceIntegration {
  listIntegrations() {
    return api.get('integrations');
  }

  createIntegration(data) {
    return api.post('integrations', data);
  }

  updateIntegration(id, data) {
    return api.put(`integrations/${id}`, data);
  }

  runIntegration(id, data = {}) {
    return api.post(`integrations/${id}/run`, data);
  }
}

export default new DataServiceIntegration();
